import { HttpContext, HttpContextToken } from '@angular/common/http';

// Background polling marks its requests silent so a transient failure (network blip,
// 429 from the rate limiter) does not pop a toast on every tick. Session errors
// (401, 403) are still handled normally.
export const SILENT_REQUEST = new HttpContextToken<boolean>(() => false);

export function silentRequestContext(): HttpContext {
  return new HttpContext().set(SILENT_REQUEST, true);
}

export function isSilentRequestError(context: HttpContext, status: number): boolean {
  return context.get(SILENT_REQUEST) && status !== 401 && status !== 403;
}
